// import { Autocomplete, Button, CircularProgress, FormControl, IconButton, InputAdornment, InputLabel, MenuItem, Select, TextField, Typography, Box, Grid, Dialog, DialogTitle, DialogContent } from "@mui/material";
// import { LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { Search as SearchIcon } from "@mui/icons-material";
// import CurrencySelector from "./CurrencySelector";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import CurrencyMaster from "../Pages/CurrencyMaster";
// import { useEffect, useState } from "react";
// import { useMediaQuery, useTheme } from "@mui/system";
// import axios from "axios";
// import { useAuth } from "../context/AuthContext";
// import { Snackbar, Alert } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";


// const PaymentReceiptStepOne = ({ bookType, handleBookTypeChange, setIsConfigInvalid, isConfigInvalid,bookTypeOptions, paymentType, setPaymentType, receiptDate, setReceiptDate, receiptNo, errors, selectedCashBook, setSelectedCashBook, cashBookOptions, cashBookTerm, setCashBookTerm, loadingCashBook, selectedParty, setSelectedParty, partyOptions, partyInput, setPartyInput, loadingParty, transactionNo, setTransactionNo, amount, setAmount, tds, setTds, roundOff, setRoundOff, totalAmt, isMultiCurrency, setIsMultiCurrency, exchangeRate, setExchangeRate, bankCharges, setBankCharges, remark, setRemark, handleNextButton, isStep1ValidForBillWise, connectionString, currencies, selectedCurrency, setSelectedCurrency, bankCashConfig }) => {
//     const path = connectionString;
//     const theme = useTheme();
//     const isSm = useMediaQuery(theme.breakpoints.down("sm"));
//     // console.log("path in step one" , path)

//     const [openCurrencyMaster, setOpenCurrencyMaster] = useState(false);
//     const [newCurrency, setNewCurrency] = useState("")
//     console.log("newCurrency", newCurrency)

//     console.log("bankCashConfig", bankCashConfig)

//     const { user, selectedCompany } = useAuth();
//     const companyId = selectedCompany?.CompId || null;

//     const [snack, setSnack] = useState({
//         open: false,
//         message: ""
//     });

//     const [configError, setConfigError] = useState("");


//     //Create helper to read config
//     const getConfigStatus = (key) => {
//         // ❌ if null OR empty → treat as NOT configured
//         if (!bankCashConfig || bankCashConfig.length === 0) return false;

//         const item = bankCashConfig.find(obj => obj[key]);

//         return item ? item[key].exists : false;
//     };


//     //Validation function
//     const validateAndBlock = (key, value, label) => {
//         const exists = getConfigStatus(key);

//         if (!exists && value && parseFloat(value) !== 0) {
//             setConfigError(`${label} is not configured!`);
//             return false; // 🚫 BLOCK typing
//         }

//         setConfigError("");
//         return true;
//     };


//     const isBank = bookType?.includes("Bank");
// const isCash = bookType?.includes("Cash");


//     return (
//         <Grid container spacing={1.5} >

//             {/* ===== ROW 1 ===== */}
//             <Grid item size={{ xs: 12 }}>
//                 <Grid container spacing={isSm ? 1 : 1.5}>
//                     <Grid item size={{ xs: 12, sm: 6 }}>
//                         <FormControl fullWidth size="small" error={errors.bookType}
//                             sx={{
//                                 '& .MuiInputBase-root': {
//                                     height: 38,
//                                 }
//                             }}>
//                             <InputLabel>Book Name</InputLabel>
//                             <Select value={bookType} label="Book Name" onChange={handleBookTypeChange} >
//                                 {bookTypeOptions.map((opt) => (
//                                     <MenuItem key={opt.value} value={opt.value}>
//                                         {opt.label}
//                                     </MenuItem>
//                                 ))}
//                             </Select>
//                         </FormControl>
//                     </Grid>

//                     <Grid item size={{ xs: 12, sm: 6 }}>
//                         <FormControl fullWidth size="small"
//                             sx={{
//                                 '& .MuiInputBase-root': {
//                                     height: 38,
//                                 }
//                             }}>
//                             <InputLabel>Payment Type</InputLabel>
//                             <Select
//                                 value={paymentType}
//                                 label="Payment Type"
//                                 onChange={(e) => setPaymentType(e.target.value)}
//                             >
//                                 <MenuItem value="OnAccount">On Account</MenuItem>
//                                 <MenuItem value="Advance">Advance</MenuItem>
//                                 <MenuItem value="BillWise">Bill Wise</MenuItem>
//                             </Select>
//                         </FormControl>
//                     </Grid>

//                     <Grid item size={{ xs: 12, sm: 6 }}>
//                         <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
//                             <DatePicker
//                                 label="Date"
//                                 value={receiptDate}
//                                 onChange={(newValue) => setReceiptDate(newValue)}
//                                 slotProps={{
//                                     textField: {
//                                         size: "small",
//                                         fullWidth: true,
//                                         sx: {
//                                             '& .MuiInputBase-root': {
//                                                 height: 38,
//                                             }
//                                         }
//                                     }
//                                 }}
//                             />
//                         </LocalizationProvider>
//                     </Grid>

//                     <Grid item size={{ xs: 12, sm: 6 }}>
//                         <TextField
//                             label="Receipt No."
//                             size="small"
//                             fullWidth
//                             value={receiptNo}
//                             InputProps={{ readOnly: true }}
//                             sx={{
//                                 '& .MuiInputBase-root': {
//                                     height: 38,
//                                 }
//                             }}
//                         />
//                     </Grid>
//                 </Grid>
//             </Grid>

//             {/* ===== ROW 2 ===== */}
//             <Grid item size={{ xs: 12 }}>
//                 <Autocomplete
//                     options={cashBookOptions}
//                     getOptionLabel={(o) => o.accountName || ""}
//                     value={selectedCashBook}
//                     onChange={(_, v) => setSelectedCashBook(v)}
//                     inputValue={cashBookTerm}
//                     onInputChange={(_, v) => setCashBookTerm(v)}
//                     loading={loadingCashBook}
//                     sx={{
//                         '& .MuiInputBase-root': {
//                             height: 38,
//                         }
//                     }}
//                     renderInput={(params) => (
//                         <TextField
//                             {...params}
//                             label={<>{isBank ? "Bank A/C" : "Cash A/C"} <span style={{ color: "red" }}>*</span></>}
//                             size="small"
//                             error={errors.selectedCashBook}
//                             InputProps={{
//                                 ...params.InputProps,
//                                 endAdornment: (
//                                     <>
//                                         {loadingCashBook && <CircularProgress size={16} />}
//                                         <InputAdornment position="end">
//                                             <IconButton size="small" >
//                                                 <SearchIcon sx={{ fontSize: "22px" }} />
//                                             </IconButton>
//                                         </InputAdornment>
//                                     </>
//                                 )
//                             }}
//                         />
//                     )}
//                 />
//             </Grid>

//             {/* ===== ROW 3 ===== */}

//             <Grid item size={{ xs: 12 }}>
//                 <Autocomplete
//                     options={partyOptions}
//                     sx={{
//                         '& .MuiInputBase-root': {
//                             height: 38,
//                         }
//                     }}
//                     getOptionLabel={(opt) => opt.clientname || ""}
//                     value={selectedParty}
//                     onChange={(_, val) => setSelectedParty(val)}
//                     inputValue={partyInput}
//                     onInputChange={(_, v) => setPartyInput(v)}
//                     loading={loadingParty}
//                     noOptionsText="No records"
//                     openOnFocus
//                     renderOption={(props, option) => {
//                         const { key, ...rest } = props;

//                         return (
//                             <li key={key} {...rest}>
//                                 <Box>
//                                     <Typography variant="body2" fontWeight="bold">
//                                         {option.clientname}
//                                     </Typography>
//                                     <Typography variant="caption" color="text.secondary">
//                                         {option.ContactPerson} | {option.City}
//                                     </Typography>
//                                 </Box>
//                             </li>
//                         );
//                     }}
//                     renderInput={(params) => (
//                         <TextField
//                             {...params}
//                             label={
//                                 <>
//                                     Party Name <span style={{ color: "red" }}>*</span>
//                                 </>
//                             }
//                             size="small"
//                             fullWidth
//                             error={errors.selectedParty}
//                             sx={{
//                                 "& .MuiInputBase-root": {
//                                     height: "2.5rem",
//                                     maxWidth: "100%",
//                                 },
//                             }}
//                             InputProps={{
//                                 ...params.InputProps,
//                                 endAdornment: (
//                                     <>
//                                         {loadingParty && <CircularProgress size={16} />}
//                                         <InputAdornment position="end">
//                                             <IconButton size="small">
//                                                 <SearchIcon sx={{ fontSize: "22px" }} />
//                                             </IconButton>
//                                         </InputAdornment>
//                                     </>
//                                 ),
//                             }}
//                         />
//                     )}
//                 />
//             </Grid>


//             {/* ===== ROW 4 ===== */}
//             <Grid item size={{ xs: 12 }}>
//                 <Grid container spacing={isSm ? 1 : 1.5}>

//                     {/* LEFT COLUMN */}
//                     <Grid item size={{ xs: 12, md: 6 }}>
//                         <Grid container direction="column" rowSpacing={isSm ? 1 : 1.5}>

//                             {isBank &&
//                                 <Grid item>
//                                     <TextField
//                                         label={<>Cheque No <span style={{ color: "red" }}>*</span></>}
//                                         size="small"
//                                         fullWidth
//                                         value={transactionNo}
//                                         error={errors.transactionNo}
//                                         onChange={(e) => setTransactionNo(e.target.value)}
//                                         sx={{
//                                             '& .MuiInputBase-root': {
//                                                 height: 38,
//                                             }
//                                         }}
//                                     />
//                                 </Grid>}


//                             <Grid item>
//                                 <TextField
//                                     label={<>Amount <span style={{ color: "red" }}>*</span></>}
//                                     size="small"
//                                     fullWidth
//                                     value={amount}
//                                     onChange={(e) => {
//                                         const val = e.target.value;

//                                         // allow only numbers and one decimal
//                                         if (/^\d*\.?\d*$/.test(val)) {
//                                             setAmount(val);
//                                         }
//                                     }}
//                                     sx={{
//                                         '& .MuiInputBase-root': {
//                                             height: 38,
//                                         }
//                                     }}
//                                 />
//                             </Grid>

//                             <Grid item>
//                                 <TextField
//                                     label="TDS"
//                                     size="small"
//                                     fullWidth
//                                     value={tds}
//                                     onBlur={() => setConfigError("")}
//                                     onChange={(e) => {
//                                         const val = e.target.value;

//                                         if (/^\d*\.?\d*$/.test(val)) {
//                                             if (!validateAndBlock("TdsAC", val, "TDS")) return; // 🚫 BLOCK
//                                             setTds(val);
//                                         }
//                                     }}
//                                     sx={{
//                                         '& .MuiInputBase-root': {
//                                             height: 38,
//                                         }
//                                     }}
//                                 />
//                             </Grid>

//                             <Grid item>
//                                 <TextField
//                                     label="Round Off"
//                                     size="small"
//                                     fullWidth
//                                     value={roundOff}
//                                     onBlur={() => setConfigError("")}
//                                     onChange={(e) => {
//                                         const val = e.target.value;

//                                         if (/^-?\d*\.?\d*$/.test(val)) {
//                                             if (!validateAndBlock("RoundOffAC", val, "Round Off")) return;
//                                             setRoundOff(val);
//                                         }
//                                     }}
//                                     sx={{
//                                         '& .MuiInputBase-root': {
//                                             height: 38,
//                                         }
//                                     }}
//                                 />
//                             </Grid>

//                             <Grid item>
//                                 <TextField
//                                     label="Total Amt"
//                                     size="small"
//                                     fullWidth
//                                     value={totalAmt}
//                                     disabled
//                                     sx={{
//                                         '& .MuiInputBase-root': {
//                                             height: 38,
//                                         }
//                                     }}
//                                 />
//                             </Grid>

//                         </Grid>
//                     </Grid>

//                     {/* RIGHT COLUMN */}
//                     <Grid item size={{ xs: 12, md: 6 }} >
//                         <Grid container direction="column" rowSpacing={isSm ? 1 : 1.5} >
//                             <Grid item>
//                                 <Box sx={{ width: "100%" }}>
//                                     <CurrencySelector
//                                         currencies={currencies}
//                                         value={selectedCurrency}
//                                         onChange={setSelectedCurrency}
//                                         exchangeRate={exchangeRate}
//                                         onExchangeRateChange={setExchangeRate}
//                                     />
//                                 </Box>
//                             </Grid>

//                             {isBank &&
//                                 <Grid item>
//                                     <TextField
//                                         label="Bank Charges"
//                                         size="small"
//                                         fullWidth
//                                         value={bankCharges}
//                                         onBlur={() => setConfigError("")}
//                                         onChange={(e) => {
//                                             const val = e.target.value;

//                                             if (!validateAndBlock("BankCommAC", val, "Bank Charges")) return;
//                                             setBankCharges(val);
//                                         }}
//                                         sx={{
//                                             '& .MuiInputBase-root': {
//                                                 height: 38,
//                                             }
//                                         }}
//                                     />
//                                 </Grid>
//                             }


//                             <Grid item>
//                                 <TextField
//                                     label="Remark"
//                                     multiline
//                                     minRows={5.2}
//                                     size="small"
//                                     fullWidth
//                                     value={remark}
//                                     onChange={(e) => setRemark(e.target.value)}
//                                 />
//                             </Grid>

//                         </Grid>
//                     </Grid>

//                 </Grid>
//             </Grid>


//             {/* ===== ROW 5 ===== */}
//             {/* {paymentType === "BillWise" && (
//                 <Grid item size={{xs:12}}>
//                     <Box display="flex" justifyContent="center" mt={2}>
//                         <Button
//                             variant="contained"
//                             size="small"
//                             onClick={handleNextButton}
//                             disabled={!isStep1ValidForBillWise}
//                         >
//                             Next
//                         </Button>
//                     </Box>
//                 </Grid>
//             )} */}

//             <Grid item size={{ xs: 12 }}>
//                 <Box display="flex" flexDirection="column" alignItems="center">

//                     {configError && (
//                         <Box display="flex" justifyContent="center" mb={1}>
//                             <Typography color="error" variant="body2" fontWeight={500}>
//                                 {configError}
//                             </Typography>
//                         </Box>
//                     )}
//                     {/* BillWise → Next */}
//                     {paymentType === "BillWise" && (
//                         <Button
//                             variant="contained"
//                             onClick={handleNextButton}
//                             disabled={!isStep1ValidForBillWise}
//                         >
//                             Next
//                         </Button>
//                     )}

//                     {/* OnAccount / Advance → Direct Save */}
//                     {(paymentType === "OnAccount" || paymentType === "Advance") && (
//                         <Button
//                             variant="contained"
//                             onClick={handleNextButton} // 
//                             disabled={!isStep1ValidForBillWise}
//                         >
//                             Save
//                         </Button>
//                     )}

//                 </Box>
//             </Grid>



//             <Dialog
//                 open={openCurrencyMaster}
//                 onClose={() => setOpenCurrencyMaster(false)}
//                 maxWidth="md"
//                 fullWidth
//             >
//                 <DialogTitle>Currency Master</DialogTitle>

//                 <DialogContent dividers>
//                     <CurrencyMaster
//                         mode={"add"}
//                         newCurrency={newCurrency}
//                         connectionString={connectionString}
//                         onPopupCancel={() => setOpenCurrencyMaster(false)}
//                     />
//                 </DialogContent>
//             </Dialog>





//         </Grid>
//     );
// };

// export default PaymentReceiptStepOne;



import { Autocomplete, Button, CircularProgress, FormControl, IconButton, InputAdornment, InputLabel, MenuItem, Select, TextField, Typography, Box, Grid, Dialog, DialogTitle, DialogContent } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Search as SearchIcon } from "@mui/icons-material";
import CurrencySelector from "./CurrencySelector";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CurrencyMaster from "../Pages/CurrencyMaster";
import { useEffect, useState } from "react";
import { useMediaQuery, useTheme } from "@mui/system";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { Snackbar, Alert } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import { getFinancialYearBounds } from "../utils/financialYear";


const PaymentReceiptStepOne = ({ isEditMode, bookType, handleBookTypeChange, disableSave, isAdvanceWithBillAllocation, selectedBills, isBillsReset, setIsConfigInvalid, isConfigInvalid, bookTypeOptions, paymentType, setPaymentType, receiptDate, setReceiptDate, receiptNo, errors, selectedCashBook, setSelectedCashBook, cashBookOptions, cashBookTerm, setCashBookTerm, loadingCashBook, selectedParty, setSelectedParty, partyOptions, partyInput, setPartyInput, loadingParty, transactionNo, setTransactionNo, amount, setAmount, tds, setTds, roundOff, setRoundOff, totalAmt, isMultiCurrency, setIsMultiCurrency, exchangeRate, setExchangeRate, bankCharges, setBankCharges, remark, setRemark, handleNextButton, isStep1ValidForBillWise, connectionString, currencies, selectedCurrency, setSelectedCurrency, bankCashConfig }) => {
    const path = connectionString;
    const theme = useTheme();
    const { startDate: fyStartDate, endDate: fyEndDate } = getFinancialYearBounds();
    const isSm = useMediaQuery(theme.breakpoints.down("sm"));

    const [openCurrencyMaster, setOpenCurrencyMaster] = useState(false);
    const [newCurrency, setNewCurrency] = useState("")

    console.log("\n\n════════════════════════════════════════════════════════════════");
    console.log("📊 PaymentReceiptStepOne - bankCashConfig received:");
    console.log("   bankCashConfig:", bankCashConfig);
    console.log("   typeof:", typeof bankCashConfig);
    console.log("   Array.isArray:", Array.isArray(bankCashConfig));
    console.log("════════════════════════════════════════════════════════════════\n");

    const { user, selectedCompany } = useAuth();
    const companyId = selectedCompany?.CompId || null;

    const [snack, setSnack] = useState({
        open: false,
        message: ""
    });

    const [configError, setConfigError] = useState("");


    // ✅ FIXED: bankCashConfig is now an OBJECT, not array
    // ✅ Map old key names to new object property names
    const getConfigStatus = (key) => {
        console.log("\n🔍 getConfigStatus called with key:", key);
        console.log("   bankCashConfig:", bankCashConfig);
        console.log("   typeof bankCashConfig:", typeof bankCashConfig);

        // ✅ Handle object, not array
        if (!bankCashConfig || typeof bankCashConfig !== 'object') {
            console.log("   → ❌ No config found (null or not object)");
            return false;
        }

        // ✅ Map old key names to new object property names
        let configKey = null;
        if (key === "TdsAC") {
            configKey = "TDSAccountId";
        } else if (key === "RoundOffAC") {
            configKey = "RoundOffAccountId";
        } else if (key === "BankCommAC") {
            configKey = "BankCommAccountId";
        }

        console.log("   → Mapped key:", configKey);
        console.log("   → bankCashConfig[" + configKey + "]:", bankCashConfig[configKey]);

        // ✅ Return true if the account ID exists (is not null/undefined)
        const hasConfig = bankCashConfig[configKey] ? true : false;
        console.log("   → Result: ", hasConfig);

        return hasConfig;
    };


    //Validation function
    // ✅ FIXED: Use new getConfigStatus logic
    const validateAndBlock = (key, value, label) => {
        console.log("\n✅ validateAndBlock called:");
        console.log("   key:", key);
        console.log("   value:", value);
        console.log("   label:", label);

        const exists = getConfigStatus(key);
        console.log("   → Config exists:", exists);

        // ✅ If value is entered but config doesn't exist, block it
        if (!exists && value && parseFloat(value) !== 0) {
            const errorMsg = `❌ ${label} is not configured in Bank/Cash Account Configuration!`;
            setConfigError(errorMsg);
            console.log("   → BLOCKED! Config missing for", label);
            return false; // 🚫 BLOCK typing
        }

        setConfigError("");
        console.log("   → ALLOWED");
        return true;
    };


    const isBank = bookType === "BKR" || bookType === "BKP";
    const isCash = bookType === "CBR" || bookType === "CBP";

    const hasBillwiseEntries = selectedBills.length > 0;


    return (
        <Grid container spacing={1.5} >

            {/* ===== ROW 1 ===== */}
            <Grid item size={{ xs: 12 }}>
                <Grid container spacing={isSm ? 1 : 1.5}>
                    <Grid item size={{ xs: 12, sm: 6 }}>
                        <FormControl fullWidth size="small" error={errors.bookType} disabled={isAdvanceWithBillAllocation}
                            sx={{
                                '& .MuiInputBase-root': {
                                    height: 38,
                                }
                            }}>
                            <InputLabel>Book Name</InputLabel>
                            <Select value={bookType} label="Book Name" onChange={handleBookTypeChange} >
                                {bookTypeOptions.map((opt) => (
                                    <MenuItem key={opt.value} value={opt.value}>
                                        {opt.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item size={{ xs: 12, sm: 6 }}>
                        <FormControl fullWidth size="small"
                            disabled={
                                isAdvanceWithBillAllocation &&
                                paymentType === "Advance"
                            }
                            sx={{
                                '& .MuiInputBase-root': {
                                    height: 38,
                                }
                            }}>
                            <InputLabel>Payment Type</InputLabel>
                            <Select
                                value={paymentType}
                                label="Payment Type"
                                onChange={(e) => setPaymentType(e.target.value)}
                            >
                                <MenuItem value="OnAccount">On Account</MenuItem>
                                <MenuItem value="Advance">Advance</MenuItem>
                                <MenuItem value="BillWise">Bill Wise</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item size={{ xs: 12, sm: 6 }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb" >
                            <DatePicker
                                label="Date"
                                disabled={isAdvanceWithBillAllocation}
                                value={receiptDate}
                                onChange={(newValue) => setReceiptDate(newValue)}
                                minDate={dayjs(fyStartDate)}
                                maxDate={dayjs(fyEndDate)}
                                slotProps={{
                                    textField: {
                                        size: "small",
                                        fullWidth: true,
                                        sx: {
                                            '& .MuiInputBase-root': {
                                                height: 38,
                                            }
                                        }
                                    }
                                }}
                            />
                        </LocalizationProvider>
                    </Grid>

                    <Grid item size={{ xs: 12, sm: 6 }}>
                        <TextField
                            label="Receipt No."
                            size="small"
                            fullWidth
                            value={receiptNo}
                            InputProps={{ readOnly: true }}
                            sx={{
                                '& .MuiInputBase-root': {
                                    height: 38,
                                }
                            }}
                            disabled={isAdvanceWithBillAllocation}
                        />
                    </Grid>
                </Grid>
            </Grid>

            {/* ===== ROW 2 ===== */}
            <Grid item size={{ xs: 12 }}>
                <Autocomplete
                    options={cashBookOptions}
                    getOptionLabel={(o) => o.accountName || ""}
                    value={selectedCashBook}
                    onChange={(_, v) => setSelectedCashBook(v)}
                    inputValue={cashBookTerm}
                    onInputChange={(_, v) => setCashBookTerm(v)}
                    loading={loadingCashBook}
                    sx={{
                        '& .MuiInputBase-root': {
                            height: 38,
                        }
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={<>{isBank ? "Bank A/C" : "Cash A/C"} <span style={{ color: "red" }}>*</span></>}
                            size="small"
                            error={errors.selectedCashBook}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {loadingCashBook && <CircularProgress size={16} />}
                                        <InputAdornment position="end">
                                            <IconButton size="small" >
                                                <SearchIcon sx={{ fontSize: "22px" }} />
                                            </IconButton>
                                        </InputAdornment>
                                    </>
                                )
                            }}
                        />
                    )}
                />
            </Grid>

            {/* ===== ROW 3 ===== */}

            <Grid item size={{ xs: 12 }}>
                <Autocomplete
                    options={partyOptions}
                    sx={{
                        '& .MuiInputBase-root': {
                            height: 38,
                        }
                    }}
                    getOptionLabel={(opt) => opt.clientname || ""}
                    value={selectedParty}
                    onChange={(_, val) => setSelectedParty(val)}
                    inputValue={partyInput}
                    onInputChange={(_, v) => setPartyInput(v)}
                    loading={loadingParty}
                    noOptionsText="No records"
                    openOnFocus
                    renderOption={(props, option) => {
                        const { key, ...rest } = props;

                        return (
                            <li key={key} {...rest}>
                                <Box>
                                    <Typography variant="body2" fontWeight="bold">
                                        {option.clientname}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        {option.ContactPerson} | {option.City}
                                    </Typography>
                                </Box>
                            </li>
                        );
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={
                                <>
                                    Party Name <span style={{ color: "red" }}>*</span>
                                </>
                            }
                            disabled={isAdvanceWithBillAllocation}
                            size="small"
                            fullWidth
                            error={errors.selectedParty}
                            sx={{
                                "& .MuiInputBase-root": {
                                    height: "2.5rem",
                                    maxWidth: "100%",
                                },
                            }}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {loadingParty && <CircularProgress size={16} />}
                                        <InputAdornment position="end">
                                            <IconButton size="small">
                                                <SearchIcon sx={{ fontSize: "22px" }} />
                                            </IconButton>
                                        </InputAdornment>
                                    </>
                                ),
                            }}
                        />
                    )}
                />
            </Grid>


            {/* ===== ROW 4 ===== */}
            <Grid item size={{ xs: 12 }}>
                <Grid container spacing={isSm ? 1 : 1.5}>

                    {/* LEFT COLUMN */}
                    <Grid item size={{ xs: 12, md: 6 }}>
                        <Grid container direction="column" rowSpacing={isSm ? 1 : 1.5}>

                            {isBank &&
                                <Grid item>
                                    <TextField
                                        label={<>Cheque No <span style={{ color: "red" }}>*</span></>}
                                        size="small"
                                        fullWidth
                                        value={transactionNo}
                                        error={errors.transactionNo}
                                        onChange={(e) => setTransactionNo(e.target.value)}
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                height: 38,
                                            }
                                        }}
                                        disabled={isAdvanceWithBillAllocation}
                                    />
                                </Grid>}


                            <Grid item>
                                <TextField
                                    label={<>Amount <span style={{ color: "red" }}>*</span></>}
                                    size="small"
                                    fullWidth
                                    value={amount}
                                    // disabled={isBillsReset}
                                    onChange={(e) => {
                                        const val = e.target.value;

                                        // allow only numbers and one decimal
                                        if (/^\d*\.?\d*$/.test(val)) {
                                            setAmount(val);
                                        }
                                    }}
                                    sx={{
                                        '& .MuiInputBase-root': {
                                            height: 38,
                                        }
                                    }}
                                    disabled={isAdvanceWithBillAllocation}
                                />
                            </Grid>

                            <Grid item>
                                <TextField
                                    label="TDS"
                                    size="small"
                                    fullWidth
                                    value={tds}
                                    
                                    onBlur={() => setConfigError("")}
                                    onChange={(e) => {
                                        const val = e.target.value;

                                        if (/^\d*\.?\d*$/.test(val)) {
                                            if (!validateAndBlock("TdsAC", val, "TDS")) return; // 🚫 BLOCK
                                            setTds(val);
                                        }
                                    }}
                                    sx={{
                                        '& .MuiInputBase-root': {
                                            height: 38,
                                        }
                                    }}
                                    disabled={paymentType === "Advance"}
                                />
                            </Grid>

                            <Grid item>
                                <TextField
                                    label="Round Off"
                                    size="small"
                                    fullWidth
                                    value={roundOff}
                                    onBlur={() => setConfigError("")}
                                    disabled={paymentType === "Advance"}
                                    onChange={(e) => {
                                        const val = e.target.value;

                                        if (/^-?\d*\.?\d*$/.test(val)) {
                                            if (!validateAndBlock("RoundOffAC", val, "Round Off")) return;
                                            setRoundOff(val);
                                        }
                                    }}
                                    sx={{
                                        '& .MuiInputBase-root': {
                                            height: 38,
                                        }
                                    }}
                                />
                            </Grid>

                            <Grid item>
                                <TextField
                                    label="Total Amt"
                                    size="small"
                                    fullWidth
                                    value={totalAmt}
                                    disabled
                                    sx={{
                                        '& .MuiInputBase-root': {
                                            height: 38,
                                        }
                                    }}
                                />
                            </Grid>

                        </Grid>
                    </Grid>

                    {/* RIGHT COLUMN */}
                    <Grid item size={{ xs: 12, md: 6 }} >
                        <Grid container direction="column" rowSpacing={isSm ? 1 : 1.5} >
                            <Grid item>
                                <Box sx={{ width: "100%" }}>
                                    <CurrencySelector
                                        currencies={currencies}
                                        value={selectedCurrency}
                                        onChange={setSelectedCurrency}
                                        exchangeRate={exchangeRate}
                                        onExchangeRateChange={setExchangeRate}
                                        disabled={isAdvanceWithBillAllocation}
                                    />
                                </Box>
                            </Grid>

                            {isBank &&
                                <Grid item>
                                    <TextField
                                        label="Bank Charges"
                                        size="small"
                                        fullWidth
                                        value={bankCharges}
                                        onBlur={() => setConfigError("")}
                                        disabled={paymentType === "Advance"}
                                        onChange={(e) => {
                                            const val = e.target.value;

                                            if (!validateAndBlock("BankCommAC", val, "Bank Charges")) return;
                                            setBankCharges(val);
                                        }}
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                height: 38,
                                            }
                                        }}
                                    />
                                </Grid>
                            }


                            <Grid item>
                                <TextField
                                    label="Remark"
                                    multiline
                                    minRows={5.2}
                                    size="small"
                                    fullWidth
                                    value={remark}
                                    onChange={(e) => setRemark(e.target.value)}
                                />
                            </Grid>

                        </Grid>
                    </Grid>

                </Grid>
            </Grid>


            {/* ===== ROW 5 ===== */}

            <Grid item size={{ xs: 12 }}>
                <Box display="flex" flexDirection="column" alignItems="center">

                    {configError && (
                        <Box display="flex" justifyContent="center" mb={1}>
                            <Typography color="error" variant="body2" fontWeight={500}>
                                {configError}
                            </Typography>
                        </Box>
                    )}

                    {/* BillWise → Next */}
                    {(
                        paymentType === "BillWise" ||
                        (paymentType === "Advance" && hasBillwiseEntries)
                    ) && (
                            <Button
                                variant="contained"
                                onClick={handleNextButton}
                                disabled={!isStep1ValidForBillWise}
                            >
                                Next
                            </Button>
                        )}

                    {/* Save Button */}
                    {(
                        paymentType === "OnAccount" ||
                        (paymentType === "Advance" && !hasBillwiseEntries)
                    ) && (
                            <Button
                                variant="contained"
                                onClick={handleNextButton}
                                disabled={disableSave}
                            >
                                Save
                            </Button>
                        )}

                </Box>
            </Grid>


            <Dialog
                open={openCurrencyMaster}
                onClose={() => setOpenCurrencyMaster(false)}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>Currency Master</DialogTitle>

                <DialogContent dividers>
                    <CurrencyMaster
                        mode={"add"}
                        newCurrency={newCurrency}
                        connectionString={connectionString}
                        onPopupCancel={() => setOpenCurrencyMaster(false)}
                    />
                </DialogContent>
            </Dialog>

        </Grid>
    );
};

export default PaymentReceiptStepOne;